// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* layout wrapper (thumb + hover preview) */
.oc-image-upload {
  position: relative;
  display: inline-flex;
  align-items: center;
}

/* hide real file input */
.oc-image-input-hidden {
  display: none;
}

/* thumb same height as input (~38px, adjust if your .oc-input is different) */
.oc-image-thumb {
  width: 38px;
  height: 38px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  background: #f9fafb;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.oc-image-thumb img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.oc-image-thumb-placeholder {
  font-size: 11px;
  color: #6b7280;
}

/* uploading state */
.oc-image-thumb.is-uploading {
  opacity: 0.7;
  pointer-events: none;
  position: relative;
}

.oc-image-thumb.is-uploading::after {
  content: "";
  position: absolute;
  inset: 6px;
  border-radius: inherit;
  border: 2px solid #9ca3af;
  border-top-color: transparent;
  animation: oc-image-spin 0.8s linear infinite;
}

@keyframes oc-image-spin {
  to {
    transform: rotate(360deg);
  }
}

/* hover big preview (does not move layout) */
.oc-image-thumb-pop {
  position: absolute;
  top: 50%;
  left: calc(100% + 8px);
  transform: translateY(-50%);
  width: 160px;
  height: 160px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #d1d5db;
  background: #ffffff;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  display: none;
  z-index: 40;
}

.oc-image-thumb-pop img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* only show preview when hovering the uploader area */
.oc-image-upload:hover .oc-image-thumb-pop {
  display: block;
}

/* optional row class if you want input + thumb on same line */
.oc-image-input-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* optional error style (if not already defined globally) */
.oc-field-error {
  margin-top: 2px;
  font-size: 12px;
  color: #b91c1c;
}

`, "",{"version":3,"sources":["webpack://./src/components/upload/css/image_uploader.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;AACf;;AAEA,8EAA8E;AAC9E;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,sDAAsD;AACtD;EACE,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,2DAA2D;AAC3D;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB","sourcesContent":["/* layout wrapper (thumb + hover preview) */\n.oc-image-upload {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n}\n\n/* hide real file input */\n.oc-image-input-hidden {\n  display: none;\n}\n\n/* thumb same height as input (~38px, adjust if your .oc-input is different) */\n.oc-image-thumb {\n  width: 38px;\n  height: 38px;\n  border-radius: 6px;\n  border: 1px solid #d1d5db;\n  background: #f9fafb;\n  overflow: hidden;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.oc-image-thumb img {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: cover;\n}\n\n.oc-image-thumb-placeholder {\n  font-size: 11px;\n  color: #6b7280;\n}\n\n/* uploading state */\n.oc-image-thumb.is-uploading {\n  opacity: 0.7;\n  pointer-events: none;\n  position: relative;\n}\n\n.oc-image-thumb.is-uploading::after {\n  content: \"\";\n  position: absolute;\n  inset: 6px;\n  border-radius: inherit;\n  border: 2px solid #9ca3af;\n  border-top-color: transparent;\n  animation: oc-image-spin 0.8s linear infinite;\n}\n\n@keyframes oc-image-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* hover big preview (does not move layout) */\n.oc-image-thumb-pop {\n  position: absolute;\n  top: 50%;\n  left: calc(100% + 8px);\n  transform: translateY(-50%);\n  width: 160px;\n  height: 160px;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid #d1d5db;\n  background: #ffffff;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\n  display: none;\n  z-index: 40;\n}\n\n.oc-image-thumb-pop img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n/* only show preview when hovering the uploader area */\n.oc-image-upload:hover .oc-image-thumb-pop {\n  display: block;\n}\n\n/* optional row class if you want input + thumb on same line */\n.oc-image-input-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* optional error style (if not already defined globally) */\n.oc-field-error {\n  margin-top: 2px;\n  font-size: 12px;\n  color: #b91c1c;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
